<template>
  <div>
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ $t('Учет животных') }}</h1>
      <div class="workroom-pg account-card-list">
        <div class="search-head bgw-pdg-20">
          <v-row>
            <v-col>
              <v-label>{{ $t('Тип карточки') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="reports"
                  item-value="id"
                  item-text="transName"
                  v-model="search.report"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
            <v-col>
              <v-label>{{ $t('Года') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="years"
                  item-value="id"
                  item-text="year"
                  v-model="search.year"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
            <v-col>
              <v-label>{{ $t('Статусы') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="statuses"
                  item-value="id"
                  item-text="transName"
                  v-model="search.status"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
            <v-col v-show="oopts.length > 1">
              <v-label>{{ $t('Организации') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="oopts"
                  item-value="id"
                  item-text="transName"
                  v-model="search.oopt"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                  @change="observePlotAndOoptObserverList"
                />
              </div>
            </v-col>
            <v-col>
              <v-label>{{ $t('Участки') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="observePlots"
                  item-value="id"
                  item-text="transName"
                  v-model="search.observePlot"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
            <v-col>
              <v-label>{{ $t('Наблюдатели') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="observers"
                  item-value="id"
                  item-text="transFio"
                  v-model="search.observer"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
          </v-row>
          <div class="search-action">
            <button
              class="btn btn-default green-grassy"
              @click="fetchData(true)"
            >
              {{ $t('Поиск') }}
            </button>
            <button
              class="btn btn-default gray"
              @click="resetForm()"
            >
              {{ $t('Очистить') }}
            </button>
          </div>
        </div>
        <div class="bgw-pdg-20 my-organization">
          <div class="add-npa-row">
            <CreateAccountCard/>
          </div>
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td>
                  <div class="sort-flex">
                    {{ $t('Тип карточки') }}
                    <a @click="sort('report')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'report' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>{{ $t('ПП') }} №</td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Участок') }}|{{ $t('Ущелье') }}
                    <a @click="sort('plot')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'plot' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('ФИО наблюдателя') }}
                    <a @click="sort('observer')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'observer' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Дата наблюдения') }}
                    <a @click="sort('date')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'date' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Год') }}
                    <a @click="sort('year')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'year' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Статус и дата присвоения') }}
                    <a @click="sort('status')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'status' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(animalAccounting, i) in data" :key="i" :style="'background-color:' + animalAccounting.color">
                <td>
                  <router-link tag="a"
                               :to="{ name: 'account-card-view', params: { id: animalAccounting.id } }"
                  >
                    {{ animalAccounting.transReportName }}{{ animalAccounting.transFaunaName ? '-' + animalAccounting.transFaunaName : '' }}
                  </router-link>
                </td>
                <td>{{ animalAccounting.number }}</td>
                <td>
                  <span v-if="animalAccounting.transObservePlotName">
                    {{ animalAccounting.transObservePlotName }}
                  </span>
                  <span v-if="animalAccounting.transCanyonName">
                    |{{ animalAccounting.transCanyonName }}
                  </span>
                </td>
                <td>{{ animalAccounting.transObserverFio }}</td>
                <td>{{ new Date(animalAccounting.dateAndTimeObservation) | dateFormat('DD.MM.YYYY HH:mm') }}</td>
                <td>{{ animalAccounting.year }}</td>
                <td>
                  {{ animalAccounting.transStatusName }}
                  <template v-if="animalAccounting.lastChange">
                    {{ new Date(animalAccounting.lastChange.date) | dateFormat('DD.MM.YYYY HH:mm') }}
                  </template>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <v-pagination
            v-model="page"
            :length="paginationData.pageCount"
            total-visible="10"
          />
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import AnimalAccounting from '@/model/animalAccounting'
import CreateAccountCard from '@/components/animalAccounting/CreateAccountCard'

export default {
  components: { CreateAccountCard },
  data: () => ({
    search: {},
    page: 1,
    paginationData: {},
    data: [],
    breadcrumbs: [],
    backUrl: process.env.VUE_APP_BACK_URL,
    sortParams: {
      field: 'date',
      order: 'DESC'
    },
    reportDialog: false,
    reports: [],
    years: [],
    statuses: [],
    oopts: [],
    observers: [],
    observePlots: []
  }),
  watch: {
    $route: 'fetchData',
    page () {
      this.fetchData()
    }
  },
  created () {
    this.searchFormData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    searchFormData () {
      this.setLoading(true)
      AnimalAccounting.getSearchFormData()
        .then((response) => {
          this.reports = response.data.ref_report
          this.years = response.data.ref_year
          this.statuses = response.data.ref_status
          this.oopts = response.data.oopts
          if (this.oopts.length === 1) {
            const oopt = this.oopts[0]
            this.search.oopt = oopt.id
            this.observePlotAndOoptObserverList(oopt.id)
          }
          this.fetchData(true)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    observePlotAndOoptObserverList (ooptId) {
      AnimalAccounting.listObservePlotAndOoptObserverByOopt(ooptId)
        .then((response) => {
          this.observePlots = response.data.observePlotArray
          this.observers = response.data.ooptObserverArray
        })
        .catch((error) => {
          console.log(error)
        })
    },
    fetchData (resetPage = false) {
      this.setLoading(true)
      if (resetPage) {
        this.page = 1
      }
      this.search.page = this.page
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order
      AnimalAccounting.list(this.search).then((response) => {
        this.data = response.data.items
        this.paginationData = response.data.paginationData

        this.breadcrumbs = [
          {
            text: this.$i18n.t('Главная'),
            disabled: false,
            href: '/'
          },
          {
            text: this.$i18n.t('Рабочий кабинет'),
            disabled: false,
            href: '/my-organization'
          },
          {
            text: this.$i18n.t('Учет животных'),
            disabled: true
          }
        ]

        this.setLoading(false)
      })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    sort (field) {
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.fetchData(true)
    },
    resetForm () {
      this.search = {}
      if (this.oopts.length === 1) {
        const oopt = this.oopts[0]
        this.search.oopt = oopt.id
      }
      this.fetchData(true)
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
